import type { ReactElement } from 'react'

import { Seo } from '@ui/components/seo'
import { BRANCH_DOWNLOAD_LINK } from '@ui/constants'
import { HeroDownload } from '@ui/hero'
import { MarketingLayout } from '@ui/layout/MarketingLayout'

const title = 'Download ATM.com App'
const description = ''

export function Index() {
  return (
    <>
      <Seo title={title} description={description} />
      <div className="relative bg-[url('/img/our-mission-bg.svg')] bg-cover bg-center pt-[120px]">
        <HeroDownload
          downloadLink={BRANCH_DOWNLOAD_LINK.website}
          className="flex min-h-[calc(100vh-112px)] flex-col items-center justify-center !bg-transparent pb-14"
          title={
            <span className="font-display tracking-wider text-[#0a2d4a]">
              DOWNLOAD THE APP
            </span>
          }
          centered={true}
        />
      </div>
    </>
  )
}

Index.getLayout = (page: ReactElement) => (
  <MarketingLayout banner={false} mainClassName="-mt-[120px]">
    {page}
  </MarketingLayout>
)

export default Index
